import { Loader2 } from "lucide-react";

/**
 * Loading state for lazily-loaded route trees (/admin/*, /platform/*).
 *
 * Deliberately not a blank div: a code-split hop on a slow connection would
 * otherwise flash empty chrome. Nested inside the admin/platform layouts, so
 * the sidebar stays put and only the page area shows this.
 */
const RouteFallback = ({ label = "Loading…" }: { label?: string }) => (
  <div
    className="flex min-h-[60vh] w-full flex-col items-center justify-center gap-3 p-8"
    role="status"
    aria-live="polite"
  >
    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-hidden="true" />
    <p className="text-sm text-muted-foreground">{label}</p>
  </div>
);

export default RouteFallback;
